export default "__VITE_ASSET__CQPk6WHj__"